import useNamespacedStorage from 'app/hooks/storage/useNamespacedStorage';

export default function useShouldAutoOpen() {
  return useNamespacedStorage<boolean>('tailorAutoOpen');
}
